meedy.factory('meedy.resourceDetailsModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.resourceDetailsService', '$q',
    function ($rootScope, applicationModel, baseModel, resourceDetailsService, $q) {

        function ResourceDetailsModel() {

            this.getDataPage = function (criteria) {
                return resourceDetailsService.getDataPage(criteria).then(
                    function (resources) {
                        return resources;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };

            this.getDataPageForCalendar = function (criteria) {
                return resourceDetailsService.getDataPageForCalendar(criteria).then(
                    function (resources) {
                        return resources;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };

            this.getResourcesAvailableForLoggedUser = function () {
                return resourceDetailsService.getResourcesAvailableForLoggedUser().then(
                    function (resources) {
                        return resources;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };

            this.getById = function (idResource) {
                return resourceDetailsService.getById(idResource).then(
                    function (resources) {
                        return resources;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };

            this.saveOrUpdate = function (resourceWrapper) {
                return resourceDetailsService.saveOrUpdate(resourceWrapper).then(
                    function (data) {
                        baseModel.broadcastOperationSucceeded();
                        return data;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };
            
            this.delete = function (idResource) {
                return resourceDetailsService.delete(idResource).then(
                    function (data) {
                        baseModel.broadcastOperationSucceeded();
                        return data;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };
        }

        return new ResourceDetailsModel();
    }
]);
